/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest,
  TelegramProductsUserControllerGenerateDescriptionFromDataMutationResponse,
  TelegramProductsUserControllerGenerateDescriptionFromData400,
  TelegramProductsUserControllerGenerateDescriptionFromData401,
  TelegramProductsUserControllerGenerateDescriptionFromData404,
} from '../../types/TelegramProductsUserControllerGenerateDescriptionFromData.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserGenerateDescriptionFromData } from '../../methods/telegramProductsUserGenerateDescriptionFromData.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserGenerateDescriptionFromDataMutationKey = () =>
  [{ url: '/api/user/telegram/products/description-generation' }] as const;

export type TelegramProductsUserGenerateDescriptionFromDataMutationKey = ReturnType<
  typeof telegramProductsUserGenerateDescriptionFromDataMutationKey
>;

/**
 * {@link /api/user/telegram/products/description-generation}
 */
export function useTelegramProductsUserGenerateDescriptionFromData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerGenerateDescriptionFromDataMutationResponse,
      ResponseErrorConfig<
        | TelegramProductsUserControllerGenerateDescriptionFromData400
        | TelegramProductsUserControllerGenerateDescriptionFromData401
        | TelegramProductsUserControllerGenerateDescriptionFromData404
      >,
      { data: TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserGenerateDescriptionFromDataMutationKey();

  return useMutation<
    TelegramProductsUserControllerGenerateDescriptionFromDataMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerGenerateDescriptionFromData400
      | TelegramProductsUserControllerGenerateDescriptionFromData401
      | TelegramProductsUserControllerGenerateDescriptionFromData404
    >,
    { data: TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramProductsUserGenerateDescriptionFromData(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
